// src/components/mobile/MobileTabNavigation.tsx
import React from 'react';
import '../../styles/mobile/mobile-common.css';

export interface MobileTab {
  id: string;
  label: string;
  icon?: React.ReactNode;
  count?: number;
}

interface MobileTabNavigationProps {
  tabs: MobileTab[];
  activeTab: string;
  onChange: (tabId: string) => void;
  className?: string;
}

export const MobileTabNavigation: React.FC<MobileTabNavigationProps> = ({
  tabs,
  activeTab,
  onChange,
  className = ''
}) => {
  return (
    <div 
      className={`mobile-tab-navigation ${className}`}
      style={{
        display: 'flex',
        height: 'var(--mobile-tab)',
        background: 'color-mix(in srgb, var(--panel-header-bg, white) 6%, white)',
        borderBottom: '1px solid var(--panel-header-border, var(--gray-200))',
        position: 'sticky',
        top: 'var(--mobile-header)',
        zIndex: 'var(--z-sticky)',
        boxShadow: 'var(--panel-shadow, 0 1px 2px rgba(0, 0, 0, 0.05))'
      }}
    >
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onChange(tab.id)}
          className="mobile-tab-button"
          style={{
            flex: 1,
            border: 'none',
            background: 'none',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 'var(--space-1)',
            fontSize: 'var(--mobile-body)',
            fontWeight: activeTab === tab.id ? 600 : 400,
            color: activeTab === tab.id ? 'var(--accent-color, var(--primary))' : 'var(--gray-600)',
            borderBottom: activeTab === tab.id ? '2px solid var(--accent-color, var(--primary))' : '2px solid transparent',
            transition: 'all 0.2s ease',
            padding: '0 var(--space-2)',
            minWidth: '44px',
            minHeight: '44px'
          }}
          aria-selected={activeTab === tab.id}
          role="tab"
        >
          {tab.icon && <span style={{ display: 'flex', alignItems: 'center' }}>{tab.icon}</span>}
          <span>{tab.label}</span>
          {tab.count !== undefined && (
            <span
              style={{
                fontSize: 'var(--mobile-tiny)',
                background: activeTab === tab.id ? 'color-mix(in srgb, var(--accent-color, var(--primary)) 14%, white)' : 'var(--gray-100)',
                color: activeTab === tab.id ? 'var(--accent-color, var(--primary))' : 'var(--gray-600)',
                padding: '2px 6px',
                borderRadius: 'var(--radius-sm)',
                fontWeight: 600
              }}
            >
              {tab.count}
            </span>
          )}
        </button>
      ))}
    </div>
  );
};
